<template>
  <div :class="{ 'express-invite': express_invite }">
    <div class="expressInvite">
      <div class="expressInvite__imgContainer">
        <img src="/static/images/logo.svg" />
      </div>

      <form class="expressInvite__form expressInvite__inner">
        <multiselect
          v-model="vacancy"
          track-by="id"
          label="name"
          class="expressInvite__multiselect"
          :options="vacanciesOpt"
          :show-labels="false"
          :allow-empty="false"
          :internal-search="false"
          :loading="loading_more"
          :placeholder="$tr('invites.vacancyFilter')"
          searchable
          @search-change="asyncFind"
        >
          <span slot="noResult">{{ $tr('vacancies.placeholders.notFound') }}</span>
          <template v-if="vacancies_total > vacanciesOpt.length" slot="afterList">
            <div class="after-list">
              <vbutton
                :text="$tr('select.button.more')"
                :disabled="loading_more"
                :loading="loading_more"
                @click="load_more"
              />
            </div>
          </template>
        </multiselect>

        <div class="expressInvite__fieldContainer">
          <vinput
            v-model="name"
            :placeholder="$tr('invites.Name') + '*'"
            name="name"
            border
            required
            focus_area
          />
        </div>

        <div class="expressInvite__fieldContainer">
          <vinput
            v-model="second_name"
            :placeholder="$tr('invites.secondName')"
            name="second_name"
            border
            focus_area
          />
        </div>

        <div class="expressInvite__fieldContainer">
          <vinput
            v-model="surname"
            :placeholder="$tr('invites.surName') + '*'"
            name="surname"
            border
            required
            focus_area
          />
        </div>

        <div class="expressInvite__fieldContainer">
          <vinput
            v-model="email"
            v-validate="'email'"
            :placeholder="$tr('invites.Email') + '*'"
            :class="{ error: email && !isEmailValid }"
            name="email"
            type="email"
            border
            required
            focus_area
          />
          <span class="form__error">{{ $tr('invites.warning.email') }}</span>
        </div>

        <div class="expressInvite__fieldContainer">
          <vphone
            v-model.lazy="phone"
            class="reg_input"
            border
            :placeholder="$tr('invites.phoneNumber')"
            :class="{
              error: !phone_valid || !phoneFull,
              valid: phone_valid
            }"
            @valid="phone_valid = $event"
            @input="inputPhone"
          />
          <span v-if="!phoneFull" class="form__error form__error__phone">
            {{ $tr('expressInvites.phoneWarning') }}
          </span>
        </div>

        <vbutton
          class="vcv-button"
          label="actions.invite"
          :loading="loaded"
          :disabled="!check_send"
          @click="send_invite"
        />
      </form>

      <modal
        v-if="open_modal"
        :email="email"
        :invite_send="invite_send"
        :repeated_invites="repeated_invites"
        :loading="loaded"
        @send="send"
        @cancel="cancel"
      />
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';
  // import MaskedInput from 'vue-masked-input';
  import modal from './components/modal.vue';

  const isEmpty = o => Object.keys(o).length === 0;

  export default {
    name: 'ExpressInvite',

    components: {
      // MaskedInput,
      modal
    },

    data() {
      return {
        vacancy: '',
        name: '',
        second_name: '',
        surname: '',
        email: '',
        phone: '',
        stage: '',
        full_name: '',
        open_modal: false,
        invite_send: false,
        phone_valid: false,
        phoneFull: true,
        loading_more: false,
        searchTerm: '',
        count: 20
      };
    },

    computed: {
      ...mapState('vacancies', ['vacancies_total', 'list_dropdown']),

      loaded() {
        return this.$store.getters['express_invites/loaded'];
      },

      express_invite() {
        return this.$store.getters['express_invites/load'];
      },

      vacanciesOpt() {
        let vacanciesArr = this.list_dropdown;

        return this.parse(vacanciesArr);
      },

      check_send() {
        return (
          this.vacancy !== '' &&
          this.name &&
          this.name !== '' &&
          this.name.trim() !== '' &&
          this.surname &&
          this.surname !== '' &&
          this.surname.trim() !== '' &&
          this.email !== '' &&
          this.isEmailValid
        );
      },

      isEmailValid() {
        if (!this.email) {
          return false;
        }
        if (this.errors.has('email') && this.errors.first('email')) {
          return false;
        }
        const re = /\S+@\S+\.\S+/;
        return re.test(this.email);
      },

      invite() {
        return {
          vacancy: {
            id: this.vacancy.id
          },

          candidate: {
            name: this.name,
            second_name: this.second_name,
            surname: this.surname,
            email: this.email,
            phone: this.phone
          },

          stage: {
            id: this.stage.id
          }
        };
      },

      repeated_invites() {
        return this.$store.getters['express_invites/repeated_invites'].length > 0;
      }
    },

    beforeMount() {
      this.fetch();
      this.checkQueryParams();
      this.load(true);
    },

    beforeDestroy() {
      this.load(false);
    },

    methods: {
      ...mapMutations('vacancies', ['CHANGE_PAGINATION_COUNT']),

      ...mapActions('vacancies', ['fetchVacanciesListDropdown']),

      // метод на случай если hh.ru в теге где телефон дублирует номер
      // spliceDoublePhone(str, val) {
      //   let indexes = [];
      //   let i = -1;
      //   let phone = '';
      //
      //   while ((i = str.indexOf(val, i + 1)) != -1) {
      //     indexes.push(i);
      //   }
      //
      //   if (indexes[1] !== undefined) {
      //     phone = str.slice(indexes[1]);
      //   }
      //
      //   return phone;
      // },

      checkQueryParams() {
        if (!isEmpty(this.$route.query)) {
          this.email = this.$route.query.email || '';

          // phone - start
          // remove duplicate phone "+7 (999) 999 99-99+7 (999) 999 99-99" => "+7 913 999 99 99"
          let phone = '';
          // phone = this.spliceDoublePhone(this.$route.query?.phone, '+');
          phone = this.$route.query?.phone;

          const phoneDigits = phone.replace(/[^0-9.]+/g, '');

          this.phone = phone && phoneDigits.length >= 10 ? phone : '';

          if (phone && phoneDigits.length < 10) {
            this.phoneFull = false;
          }
          // phone - end

          this.full_name = this.$route.query?.name || '';

          this.get_area();
        }
      },

      inputPhone() {
        this.phoneFull = true;
      },

      get_area() {
        let area_name = this.full_name.split(' ');

        this.name = area_name[1];
        this.second_name = area_name[2];
        this.surname = area_name[0];
      },

      fetch() {
        this.loading_more = true;
        let params = {
          searchTerm: this.searchTerm,
          isActive: true
        };

        this.fetchVacanciesListDropdown(params)
          .then(data => {
            this.loading_more = false;
            return data;
          })
          .catch(() => {
            this.loading_more = false;
          });
      },

      asyncFind(v) {
        this.searchTerm = v;
        this.fetch();
      },

      load_more() {
        this.count = this.count + 20;
        this.CHANGE_PAGINATION_COUNT(this.count);
        this.fetch();
      },

      parse(array) {
        return array.map(vacancy => {
          return {
            id: vacancy.id,
            name: vacancy.name
          };
        });
      },

      send_invite() {
        this.$store.dispatch('express_invites/check_dublicate', this.invite).then(() => {
          this.toggle_modal();
          if (!this.repeated_invites) {
            this.send();
          }
        });
      },

      send() {
        this.$store
          .dispatch('express_invites/send', this.invite)
          .then(() => {
            this.clear_form();
            this.invite_send = true;
          })
          .catch(err => {
            if (err.response === undefined) {
              this.$noty.error(this.$tr('common.error.networkError'));
            } else {
              this.$store.dispatch('global/setError', err);
            }
          });
      },

      cancel() {
        this.invite_send = false;
        this.toggle_modal();
      },

      toggle_modal() {
        this.open_modal = !this.open_modal;
      },

      clear_form() {
        this.vacancy = '';
        this.name = '';
        this.second_name = '';
        this.surname = '';
        this.email = '';
        this.phone = '';
      },

      load(val) {
        this.$store.commit('express_invites/set_load', val);
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/queries.scss';
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.expressInvite__multiselect {
  width: 200px;
}

.expressInvite__multiselect:last-child {
  margin-right: 0;
}

.expressInvite__multiselect .multiselect__tags {
  border-radius: 3px;
  padding-left: 10px;
}

.expressInvite__multiselect .multiselect__content-wrapper {
  border-radius: 3px;
}

.expressInvite__multiselect_red .multiselect__tags {
  border: 1px solid $red-color;
}

.fade-enter {
  transform: translateX(-10%);
  opacity: 0;
}

.fade-leave-to {
  transform: translateX(10%);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
}

.expressInvite {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 20px 20px 52px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  position: relative;

  &__imgContainer {
    margin-right: 5%;

    img {
      width: 87px;
    }
  }

  &__info {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;

    &_red {
      color: $red-color;
    }

    &_green {
      color: $green;
    }
  }

  &__inner {
    display: flex;
    width: 100%;
  }

  &__form {
    display: flex;
    margin-top: 30px;
    justify-content: space-between;

    * {
      min-width: 150px;
    }
  }

  &__fieldContainer {
    position: relative;

    &:last-child {
      margin-right: 0;
    }
  }

  &__field {
    width: 150px;
    height: 37px;
    border: 1px solid #ccc;
    border-radius: 3px;
    padding-left: 15px;
  }

  ::v-deep {
    .after-list {
      padding: 10px;
      border-top: 1px solid #ccc;
      margin-top: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .multiselect__spinner {
      width: 28px;
      height: 14px;

      &:before,
      &:after {
        width: 10px;
        height: 10px;
        right: 0px;
      }
    }

    .vinput input {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  .form__error {
    position: absolute;
    left: 5px;
    bottom: -18px;
    width: 200px;
    color: $red-color;
    text-align: left;
    font-size: 12px;
    display: block;
    margin-top: 3px;
    display: none;

    &.form__error__phone {
      display: block;
    }
  }

  &__multiselect {
    min-width: 280px;
  }

  input:valid:not(:placeholder-shown) {
    border-color: $green;
  }

  input:invalid:not(:placeholder-shown) {
    border-color: $red-color;
  }
  input:invalid:not(:placeholder-shown) + .form__error {
    display: block;
  }
}

.expressInvite__form {
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > * {
    width: 280px;
    max-width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }

  .expressInvite__fieldContainer {
    display: flex;
    flex-direction: column;

    .expressInvite__field {
      width: 100%;
    }
    .form__error {
      position: relative;
      left: initial;
      bottom: initial;
    }

    .reg_input {
      margin-top: 0;
    }
  }

  .vcv-button {
    margin-top: 30px;
  }
}

.error {
  margin-top: 0;
  ::v-deep {
    input {
      border-color: #f65046 !important;
    }
  }
}
</style>
